import { QueryCache, QueryClient, QueryClientProvider as TanStackQueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';

import { observabilityAppService } from '../utils/ObservabilityAppService';

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (error && query) {
        observabilityAppService.notify(error, { queryKey: query.queryKey });
      }
    },
  }),
});

export function QueryClientProvider({ children }: { children: ReactNode }) {
  return <TanStackQueryClientProvider client={queryClient}>{children}</TanStackQueryClientProvider>;
}
